import { render, staticRenderFns } from "./ChangeLeadUnityDialog.vue?vue&type=template&id=bb36792c&"
import script from "./ChangeLeadUnityDialog.vue?vue&type=script&lang=js&"
export * from "./ChangeLeadUnityDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports